var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 600,
        width: 1900,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "165", width: "1837", y: "40.95001", x: "30.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "289", width: "1835", y: "252.95001", x: "34.5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }